import { AspectRatioVariant, BorderRadius, FilesPreview, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { getImageClassName } from '../../../../../../utils/getClassName'
import { useAttachmentPreviewModal } from '../../context/attachmentPreviewModalContext'
import * as Styled from './styles'

export const AttachmentPreview = (): ReactElement => {
  const { files } = useAttachmentPreviewModal()

  return (
    <Styled.AttachmentPreviewWrapper>
      <FilesPreview
        aspectRatio={AspectRatioVariant.billAttachment}
        borderRadius={BorderRadius.R12}
        className={getImageClassName()}
        files={files}
        fitToHeight
        isFloatingActionsView
        margin={Spacing.S16}
        withDownloadButton
        withRotate
        withShadow
        zoomable
      />
    </Styled.AttachmentPreviewWrapper>
  )
}
